import { Injectable } from '@angular/core';

declare var gtag: any;

/** gtag is injected into index.html only when window.__env.production === true, so it's absent in non-production deploys. */
function isGtagAvailable(): boolean {
  return typeof gtag === 'function';
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  trackEvent(eventName: string, eventDetails: string, eventCategory: string) {
    if (!isGtagAvailable()) {
      return;
    }
    gtag('event', eventName, {
      event_category: eventCategory,
      event_label: eventName,
      value: eventDetails,
    });
  }

  trackUrl(url: string) {
    if (!isGtagAvailable()) {
      return;
    }
    gtag('event', 'page_view', {
      page_location: url,
      page_title: document.title,
    });
  }
}
